import React from 'react';
export function FitFilterSection() {
  return <section id="fit" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-69">
      <div className="mb-20" data-id="element-70">
        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-71">
          Fit Filter
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-black" data-id="element-72">
          Who this is (and isn't) for
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24" data-id="element-73">
        <div data-id="element-74">
          <h4 className="text-xl font-medium text-black mb-8 pb-2 border-b border-gray-200 inline-block" data-id="element-75">
            This fits if:
          </h4>
          <ul className="space-y-6" data-id="element-76">
            <li className="flex items-start" data-id="element-77">
              <span className="mr-4 text-black font-medium" data-id="element-78">—</span>
              <span className="text-lg text-gray-600" data-id="element-79">
                You're pre-PMF or at a moment where the next milestone carries
                outsized consequences
              </span>
            </li>
            <li className="flex items-start" data-id="element-80">
              <span className="mr-4 text-black font-medium" data-id="element-81">—</span>
              <span className="text-lg text-gray-600" data-id="element-82">
                Runway feels tight and expectations are rising
              </span>
            </li>
            <li className="flex items-start" data-id="element-83">
              <span className="mr-4 text-black font-medium" data-id="element-84">—</span>
              <span className="text-lg text-gray-600" data-id="element-85">
                Time feels like the scarcest resource right now
              </span>
            </li>
            <li className="flex items-start" data-id="element-86">
              <span className="mr-4 text-black font-medium" data-id="element-87">—</span>
              <span className="text-lg text-gray-600" data-id="element-88">
                You've raised ahead of your operating maturity
              </span>
            </li>
            <li className="flex items-start" data-id="element-89">
              <span className="mr-4 text-black font-medium" data-id="element-90">—</span>
              <span className="text-lg text-gray-600" data-id="element-91">
                You need momentum without taking on a long-term hire
              </span>
            </li>
          </ul>
        </div>

        <div data-id="element-92">
          <h4 className="text-xl font-medium text-black mb-8 pb-2 border-b border-gray-200 inline-block" data-id="element-93">
            This won't fit if:
          </h4>
          <ul className="space-y-6" data-id="element-94">
            <li className="flex items-start" data-id="element-95">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-96">—</span>
              <span className="text-lg text-gray-400" data-id="element-97">
                You're looking for junior help or simple task delegation
              </span>
            </li>
            <li className="flex items-start" data-id="element-98">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-99">—</span>
              <span className="text-lg text-gray-400" data-id="element-100">
                You want validation more than forward progress
              </span>
            </li>
            <li className="flex items-start" data-id="element-101">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-102">—</span>
              <span className="text-lg text-gray-400" data-id="element-103">
                You're optimizing for scale rather than near-term execution
              </span>
            </li>
            <li className="flex items-start" data-id="element-104">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-105">—</span>
              <span className="text-lg text-gray-400" data-id="element-106">
                You're not open to focused, time-bound changes
              </span>
            </li>
            <li className="flex items-start" data-id="element-107">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-108">—</span>
              <span className="text-lg text-gray-400" data-id="element-109">
                You want someone to avoid hard conversations
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}